module.exports = __webpack_public_path__ + "static/img/mc.dd2c6d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/mc.png
// module id = T5qc
// module chunks = 0 139